import styled from "styled-components";
import { GenericIcon } from "@swiggy-private/dls-web-icons/dist/GenericIconWeb";

const ADD_NEW_ICON_WIDTH = 36;
const ADD_NEW_ICON_HEIGHT = 24;

export const PaymentMethod = styled.div<{ $isDisabled: boolean }>(({ $isDisabled }) => ({
    padding: "17px 0",
    margin: "0 16px",
    overflow: "hidden",
    opacity: $isDisabled ? 0.7 : 1,

    "&:last-child": {
        borderBottom: "none",
    },
}));

export const PaymentMethodContainer = styled.div(() => ({
    display: "flex",
    width: "100%",
}));

export const IconContainer = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "flex-start",
    width: `${ADD_NEW_ICON_WIDTH}px`,
    height: `${ADD_NEW_ICON_HEIGHT}px`,
    borderRadius: "6px",
    border: `1px solid ${theme.colors[theme.colorMode].border_Secondary}`,
}));

export const Icon = styled(GenericIcon)<{
    $isDisabled: boolean;
}>(({ $isDisabled }) => ({
    filter: $isDisabled ? "grayscale(100%)" : "none",
    position: "relative",
}));

export const AlertMessage = styled.div(() => ({
    marginTop: "2px",
    marginLeft: "0",
}));

export const NonTokenizeCardRemovalContainer = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    border: `1px solid ${theme.colors[theme.colorMode].divider}`,
    borderRadius: "16px",
    marginTop: "18px",
    padding: "8px 16px 8px 10px",
}));

export const NonTokenizeCardRemovalMsg = styled.div(() => ({
    paddingLeft: "10px",
}));
